module.exports = __webpack_public_path__ + "static/media/55_000013.7539e648.jpg";